import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppLoaderProgressComponent } from './app-loader-progress.component';
import {Log} from '../../interfaces/log'

interface Config {
  width?: string
}

@Injectable()
export class AppLoaderProgressService {
  myObservable;
  dialogRef: MatDialogRef<AppLoaderProgressComponent>;
  constructor(private dialog: MatDialog) { }
  public open(myObservable: Observable<Log>, title: string = 'Processando...', config: Config = {width: '300px'}): Observable<boolean> {
    this.myObservable = myObservable;
    this.dialogRef = this.dialog.open(AppLoaderProgressComponent, { disableClose: true, backdropClass: 'light-backdrop'});
    this.dialogRef.updateSize(config.width);
    this.dialogRef.componentInstance.title = title;
    this.myObservable.subscribe(
      (response: Log) => {
        if (response !== null && this.dialogRef.componentInstance !== null) {
          const perc = (response.workDone * 100) / response.max;
          this.dialogRef.componentInstance.value = perc;
          this.dialogRef.componentInstance.title = response.log ? response.log : '' + `(${perc !== undefined ? perc : 0}%)`;
          if (response.workDone !== null && response.workDone !== undefined && response.workDone === response.max) {
            // this.dialogRef.close();
            this.dialogRef.componentInstance.finished = true;
            // this.dialogRef.componentInstance.title = 'FINALIZADO!';
          }
        }
        if (response === null || response.uuid === '') {
          this.dialogRef.close();
        }
      },
      (error) => {
        this.dialogRef.close();
      }
    );
    return this.dialogRef.afterClosed();
  }

  public close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
